import { ExperimentService } from './experiment';

/**
 * We're exposing an instance of the ExperimentService class, so we can have a singleton service.
 *
 * Usage:
 *
 * import experiment, { AnonymousTarget } from '@hotjar/experimentation';
 *
 * const target = new AnonymousTarget();
 * experiment.getVariant('atv_experiment_id', target).then(({ variant, targetId, inExperiment }) => {
 *    if (inExperiment) {
 *      // Do tracking here
 *    }
 * });
 *
 */
export const experimentService = new ExperimentService();

export {
  AccountTarget,
  UserTarget,
  SiteTarget,
  AnonymousTarget,
  UserWithAnonIdTarget,
  TrafficCoverageTarget,
} from './targets';

export { getVariantFromUrl } from './overrides';

export { VARIANTS } from './constants';

export type { ExperimentData } from './experiment';

export { optimizely } from './optimizely';

export { useOptimizelyFeatureForUser } from './useOptimizelyFeatureForUser';

export type { AuthenticatedUser, UserTargetAttributes } from './targets/UserTarget';

export type { TrafficTargetAttributes } from './targets/TrafficCoverageTarget';

export type { BaseAttributes } from './targets/BaseTarget';

export type { AnonymousExperimentAttributes } from './targets/AnonymousTarget';
